import styled from 'styled-components';

import { StyledControlBarButton } from '../control-bar-button.styles';

export const StyledShowThumbnailsSidebarButton = styled(StyledControlBarButton)`
  margin: 0 2em;
  @media all and (max-width: 1200px) {
    margin: 0 20px;
  }
`;
